import Modal from "@components/atoms/Modal";
import React from "react";
import { ListViewModalProps } from "./types";
import { useTranslation } from "react-i18next";
import ArrangeListViewScreen from "./ArrangeListViewScreen";
import { SearchFilterTypeEnum } from "@components/atoms/Filters/utils";

const ArrangeListViewScreenModal = ({
  isOpen,
  onClose,
  productType,
  onApply,
  onReset,
  selectedSortingFilters,
  backgroundColor,
  sectionName = SearchFilterTypeEnum.SINGLE_STONES,
}: ListViewModalProps) => {
  const { t } = useTranslation();
  return (
    <Modal
      headerTitle={t("ListViewScreen.modal.title.text")}
      isOpen={isOpen}
      onClose={onClose}
      paddingLeft={8}
      paddingRight={8}
      paddingBottom={0}
      paddingTop={16}
      backgroundColor={backgroundColor}
      skipKeyboardAware={true}
      noPadding={true}
      enableToastMessage
    >
      <ArrangeListViewScreen
        onClose={onClose}
        productType={productType}
        onApply={onApply}
        onReset={onReset}
        selectedSortingFilters={selectedSortingFilters ?? []}
        sectionName={sectionName}
      />
    </Modal>
  );
};

export default ArrangeListViewScreenModal;
